import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NftDetail = () => {
  const [nfts, setNfts] = useState([
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft21.png",
    },
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft22.png",
    },
    {
      name: "TITULO",
      val: "0,01",
      price: "300,00€",
      img: "./images/nft21.png",
    },
  ]);
  return (
    <div className="nft-detail flex flex-col">
      <div className="nft-title-sec flex aic jc">
        <div className="nft-title">TITULO</div>
      </div>
      <div className="wrap wrapWidth flex flex-col">
        <div className="about-nft flex aic">
          <div className="left flex aic jc">
            <img src="./images/nft21.png" className="img" />
          </div>
          <div className="right flex flex-col">
            <div className="detail-block flex flex-col">
              <div className="share-action flex aic justify-end">
                <img src="./images/shareIcon.png" className="img" />
              </div>
              <div className="desc">
                A community-driven collectibles project featuring art by Burnt
                Toast. Doodles come in a joyful range of colors, traits and
                sizes with a collection size of 10,000.
              </div>
              <div className="about-auth flex aic">
                <div className="user flex flex-col">
                  <div className="user-name">CREADOR</div>
                  <div className="user-info flex aic">
                    <img src="./images/auth_users.png" className="user-img" />
                    <div className="user-tag">@autor</div>
                  </div>
                </div>
                <div className="user flex flex-col">
                  <div className="user-name">COLECCIÓN</div>
                  <div className="user-info flex aic">
                    <img src="./images/auth_users.png" className="user-img" />
                    <div className="user-tag">Nombre</div>
                  </div>
                </div>
              </div>
              <div className="user-details flex aic">
                <div className="left flex flex-col w-full">
                  <div className="tabs flex">
                    <div className="tab">Detalles</div>
                    <div className="tab">Historial</div>
                  </div>
                  <div className="user flex flex-col">
                    <div className="user-name">Propietario</div>
                    <div className="user-info flex aic">
                      <img src="./images/auth_users.png" className="user-img" />
                      <div className="user-tag">Nombre</div>
                    </div>
                  </div>
                  <div className="prop flex flex-col">
                    <div className="prog-tag">Propiedades y beneficios</div>
                    <div className="pro-item flex">
                      <div className="dot"></div>
                      <div className="lbl">Royalties del 10%</div>
                    </div>
                    <div className="pro-item flex">
                      <div className="dot"></div>
                      <div className="lbl">Beneficio 1</div>
                    </div>
                    <div className="pro-item flex">
                      <div className="dot"></div>
                      <div className="lbl">Beneficio 2</div>
                    </div>
                    <div className="pro-item flex">
                      <div className="dot"></div>
                      <div className="lbl">Beneficio 3</div>
                    </div>
                  </div>
                </div>
                <div className="right flex"></div>
              </div>
              <div className="actions flex aic">
                <div className="a-left flex aic">
                  <img src="./images/Ethereum.svg" className="ico" />
                  <div className="meta flex flex-col aic">
                    <div className="val">0,01</div>
                    <div className="price">300,00€</div>
                  </div>
                </div>
                <div className="a-right flex">
                  <div className="btn button w-full">COMPRAR</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="about-user flex flex-col">
          <div className="ab-u-tital">SOBRE EL ARTISTA</div>
          <div className="ab-u-block flex aic">
            <div className="ab-left flex flex-col aic">
              <img src="./images/auth_users.png" className="u-img" />
              <div className="u-lbl">Nombre</div>
              <div className="social flex aic">
                <div className="icon">
                  <img src="./images/instagram.png" className="img" />
                </div>
                <div className="icon">
                  <img src="./images/tik-tok.png" className="img" />
                </div>
                <div className="icon">
                  <img src="./images/facebook.png" className="img" />
                </div>
                <div className="icon">
                  <img src="./images/globe.png" className="img" />
                </div>
              </div>
            </div>
            <div className="ab-right flex flex-col">
              <div className="ab-u-desc">
                A community-driven collectibles project featuring art by Burnt
                Toast. Doodles come in a joyful range of colors, traits and
                sizes with a collection size of 10,000.A community-driven
                collectibles project featuring art by Burnt Toast. Doodles come
                in a joyful range of colors, traits and sizes with a collection
                size of 10,000.A community-driven collectibles project featuring
                art by Burnt Toast. Doodles come in a joyful range of colors,
                traits and sizes with a collection size of 10,000.
              </div>
              <div className="award-tag">Premios y reconocimientos</div>
            </div>
          </div>
        </div>
        <div className="related-nfts flex flex-col">
          <div className="related-tag">Otros NFTs del artista</div>
          <div className="nfts-side">
            {nfts.map((item, index) => (
              <div className="nft-card flex flex-col">
                <div
                  className="nft-img flex"
                  style={{ backgroundImage: `url(${item.img})` }}
                >
                  <div className="about-auth flex aic">
                    <img src="./images/auth_users2.png" className="user-img" />
                    <div className="user-tag">@autor</div>
                  </div>
                </div>
                <div className="nft-info flex flex-col">
                  <div className="name">TITULO</div>
                  <div className="actions flex aic jc">
                    <img src="./images/Ethereum.svg" className="ico" />
                    <div className="meta flex flex-col aic">
                      <div className="val">0,01</div>
                      <div className="price">300,00€</div>
                    </div>
                    <Link to="/NftDetail" className="btn button">
                      COMPRAR
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="related-tag">Otros NFTs que te pueden interesar</div>
          <div className="nfts-side">
            {nfts.map((item, index) => (
              <div className="nft-card flex flex-col">
                <div
                  className="nft-img flex"
                  style={{ backgroundImage: `url(${item.img})` }}
                >
                  <div className="about-auth flex aic">
                    <img src="./images/auth_users2.png" className="user-img" />
                    <div className="user-tag">@autor</div>
                  </div>
                </div>
                <div className="nft-info flex flex-col">
                  <div className="name">TITULO</div>
                  <div className="actions flex aic jc">
                    <img src="./images/Ethereum.svg" className="ico" />
                    <div className="meta flex flex-col aic">
                      <div className="val">0,01</div>
                      <div className="price">300,00€</div>
                    </div>
                    <Link to="/NftDetail" className="btn button">
                      COMPRAR
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NftDetail;
